


















import Enumerable from "linq";
import { ElTree } from "element-ui/types/tree";
import { Component, Mixins, Prop, Watch, Model, Emit } from "vue-property-decorator";
import { Directory } from "../../../../../../domain/drawing";
import { ITreeExpandable, ITreeInformation } from "../../../../../system";
import { DirectoryTreeNodesFactory } from "../../../../../system/utilities/DirectoryTreeNodesFactory";
import { ClaioImageRootReference } from "../ClaioImageRootReference";
import { ClaioImageReference } from "../ClaioImageReference";
import { IClaioImageReferenceTreeData } from "./IClaioImageReferenceTreeData";
import { IClaioImageReferenceTreeNode } from "./IClaioImageReferenceTreeNode";

@Component
export default class ClaioContentsTreeSelector extends Mixins() implements ITreeExpandable, ITreeInformation {
  @Model("input")
  value: ClaioImageReference;

  @Prop()
  claioImageRoot: ClaioImageRootReference;

  @Emit()
  input(value: ClaioImageReference): any {}

  $refs!: {
    tree: ElTree<number, IClaioImageReferenceTreeData>,
  };

  data(): any {
    return {
      selectedReference: null as ClaioImageReference,
      selectedNode: null as IClaioImageReferenceTreeNode,
    };
  }
  selectedReference: ClaioImageReference;
  selectedNode: IClaioImageReferenceTreeNode;

  get isLoaded(): boolean {
    return (this.nodes !== null)
      && (this.nodes !== undefined)
      && (0 < this.nodes.length);
  }

  get nodes(): IClaioImageReferenceTreeData[] {
    const factory = new DirectoryTreeNodesFactory(this.toClaioImageNode);
    return factory.create(this.claioImageRoot
      ? this.claioImageRoot.folders
      : []);
  }

  get selectedKey(): number {
    return this.selectedNode
      ? this.selectedNode.key
      : null;
  }

  expandTree(): void {
    if (!this.isLoaded) { return; }
    const node = this.$refs.tree as any; // rootが必要なのでanyに変換
    this.expandNode(node.root);
  }

  clearSelection(): void {
    this.selectedReference = null;
    this.selectedNode = null;
    if (this.$refs.tree) {
      this.$refs.tree.setCurrentKey(null);
    }
  }

  private expandNode(node: IClaioImageReferenceTreeNode): void {
    if (node.data instanceof Object) {
      if (node.data.source instanceof Directory) {
        this.expandDirectory(node);
      }
    }
    if (node.childNodes instanceof Array) {
      node.childNodes.forEach((t) => this.expandNode(t));
    }
  }

  private expandRootNode(): void {
    this.$nextTick(() => {
      const node = this.$refs.tree as any; // rootが必要なのでanyに変換
      if (!node) { return; }
      const rootNode = node.root as IClaioImageReferenceTreeNode;
      if (rootNode.childNodes instanceof Array) {
        const directories = Enumerable.from(rootNode.childNodes)
          .where(n => n.data instanceof Object && n.data.source instanceof Directory)
          .toArray();
        // ルートフォルダが1つしかない場合自動選択
        if (directories.length === 1) {
          const root = Enumerable.from(directories).first();
          this.expandDirectory(root);
        }
      }
    });
  }

  private expandDirectory(node: IClaioImageReferenceTreeNode): void {
    node.expanded = true;
    node.data.iconClass = "tree-icon-directory-expand";
  }

  expandKeys(): number[] {
    if (!this.isLoaded) { return; }
    const node = this.$refs.tree as any; // rootが必要なのでanyに変換
    return this.expandNodeKeys(node.root);
  }

  private expandNodeKeys(node: IClaioImageReferenceTreeNode, keys: number[] = []): number[] {
    if (node.data instanceof Object) {
      if (node.data.source instanceof Directory && node.expanded) {
        keys.push(node.key);
      }
    }
    if (node.childNodes instanceof Array) {
      node.childNodes.forEach((t) => this.expandNodeKeys(t, keys));
    }
    return keys;
  }

  toClaioImageNode(entity: ClaioImageReference, i: number): IClaioImageReferenceTreeData {
    return {
      id: i,
      label: entity.text,
      iconClass: "tree-icon-claio-image",
      source: entity,
      children: [],
    };
  }

  updateNodeExpand(nodeObject: IClaioImageReferenceTreeData, nodeProperty: IClaioImageReferenceTreeNode, nodeSelf: any): void {
    if (nodeProperty.data.source instanceof Directory) {
      // nodeSelfは直前の状態の模様。そのため判定は逆になる
      nodeObject.iconClass = nodeSelf.expanded
        ? "tree-icon-directory"
        : "tree-icon-directory-expand";
    }
  }

  handleNodeClicked(nodeObject: IClaioImageReferenceTreeData, nodeProperty: IClaioImageReferenceTreeNode, nodeSelf: any): void {
    const source = nodeObject.source;
    if (source instanceof ClaioImageReference) {
      this.selectedReference = source;
    }
    if (source instanceof Directory) {
      this.selectedReference = new ClaioImageReference(
        "",
        source.entities[0].imageDate,
        source.entities[0].imageKind,
        source.entities[0].departmentId,
        null
      );
    }
    this.selectedNode = nodeProperty;
  }

  @Watch("selectedReference")
  onSelectedReferenceUpdated(newValue: ClaioImageReference): void {
    this.input(newValue);
  }

  @Watch("nodes")
  onNodeUpdated(newValue: IClaioImageReferenceTreeData[]): void {
    if (!!newValue) {
      this.expandRootNode();
    }
  }
}
